/**
 * Correspondance comptes opérationnels Nexxus ↔ PCG SYSCOHADA 2026.
 * Source : REFERENCE_COMPTA_SYSCOHADA_2026.xlsx.
 */

/** TVA facturée / collectée — référentiel 442 ; alias moteur 4431 / 4457. */
export const COMPTES_TVA_COLLECTEE = ['442', '4431', '4457'] as const;

/** TVA due (clôture de période) — référentiel 443. */
export const COMPTES_TVA_DUE = ['443'] as const;

/** TVA récupérable — référentiel 444 ; ventilation moteur 4451 (immo) / 4452 (biens) / 4456. */
export const COMPTES_TVA_RECUPERABLE = ['444', '4451', '4452', '4456'] as const;

export function estTvaCollectee(compte: string): boolean {
  const c = compte.trim();
  if (c === '442' || c.startsWith('4431') || c === '4457' || c.startsWith('4457')) return true;
  return false;
}

export function estTvaDue(compte: string): boolean {
  const c = compte.trim();
  return c === '443' || (c.startsWith('443') && !c.startsWith('4431'));
}

export function estTvaRecuperableImmo(compte: string): boolean {
  return compte.trim().startsWith('4451');
}

export function estTvaRecuperableBiens(compte: string): boolean {
  const c = compte.trim();
  return c === '444' || c.startsWith('444') || c === '4452' || c.startsWith('4452') || c === '4456' || c.startsWith('4456');
}

export function estTvaRecuperable(compte: string): boolean {
  return estTvaRecuperableImmo(compte) || estTvaRecuperableBiens(compte);
}

/** Amortissements / dépréciations à netter à l’actif (présentation « nette » SYSCOHADA). */
export function estCompteContraActif(compte: string): boolean {
  return /^(27|28|29|39|49|590)/.test(compte.trim());
}

export function racineDeux(compte: string): string {
  return compte.trim().slice(0, 2);
}
